import React from 'react';
import {render} from 'react-dom';

var FileDiffs = React.createClass({
	getInitialState: function(){
		return {heightt: 393}
	},
	render: function(){
		var result = [];
		var diff = this.props.data;
		var count = 0;
		var oldCount = 1;
		var newCount = 1;
		for (var i in diff){
			if(!diff[i]["added"] && !diff[i]["removed"]){
				if(!!diff[i]["value"] && diff[i]["value"].search("\n") > -1){
					var temp = diff[i]["value"].split("\n");
					for (var j in temp){
						if(temp[j] === "") continue;
						if(temp.length > 6){
							if(parseInt(j) >= temp.length-5){
								count = 0;
							}
						}
						if(count == 3){
							result.push(<tr className ="line_holder match" key = {i+j}>
			                  <td className ="diff-line-num old_line">...</td>
			                  <td className ="diff-line-num new_line">...</td>
			                  <td className ="line_content match"><span className="line_content-inner">@@ collapsed lines @@</span></td>
			                </tr>);
			                count++;
						} else if (count < 3) {
							result.push(<tr className="line_holder" key = {i+j}>
				                  <td className="diff-line-num old_line">{oldCount}</td>
				                  <td className="diff-line-num new_line">{newCount}</td>
				                  <td className="line_content noteable_line"><span className="line_content-inner">{temp[j]}</span></td>
				                </tr>);
							oldCount++;
							newCount++;
							count ++;
						} else {
							oldCount++;
							newCount++;
							count++;
						}
					}
				} else {
					result.push(<tr className="line_holder" key = {i}>
				                  <td className="diff-line-num old_line">{oldCount}</td>
				                  <td className="diff-line-num new_line">{newCount}</td>
				                  <td className="line_content noteable_line"><span className="line_content-inner">{diff[i]["value"]}</span></td>
				                </tr>);
					oldCount++;
					newCount++;
				}
			} else if (!diff[i]["removed"]){
				count = 0;
				if(!!diff[i]["value"] && diff[i]["value"].search("\n") > -1){
					var temp = diff[i]["value"].split("\n");
					if(temp.length >30){
			           temp = temp.splice(0, 30);
			        }
					for (var k in temp){
						if(temp[k] === "") continue;
						result.push(<tr className="line_holder old" key = {diff[i]["value"]+ k}>
		                  <td className="diff-line-num old_line old">{oldCount}</td>
		                  <td className="diff-line-num new_line old"></td>
		                  <td className="line_content noteable_line old"><span className="line_content-inner">{temp[k]}</span></td>
		                </tr>);
						oldCount++;
					}
				} else {
					result.push(<tr className="line_holder old" key = {i}>
			                  <td className="diff-line-num old_line old">{oldCount}</td>
			                  <td className="diff-line-num new_line old"></td>
			                  <td className="line_content noteable_line old"><span className="line_content-inner">{diff[i]["value"]}</span></td>
			                </tr>);
					oldCount++;
				}
			} else if(!diff[i]["added"]){
				count = 0;
				if(!!diff[i]["value"] && diff[i]["value"].search("\n") > -1){
					var temp = diff[i]["value"].split("\n");
					if(temp.length >30){
			            temp = temp.splice(0, 30);
			        }
					for (var m in temp){
						if(temp[m] === "") continue;
						result.push( <tr className="line_holder new" key = {m + diff[i]["value"]}>
			                  <td className="diff-line-num old_line new"></td>
			                  <td className="diff-line-num new_line new">{newCount}</td>
			                  <td className="line_content noteable_line new"><span className="line_content-inner">{temp[m]}</span></td>
			                </tr>);
						newCount++;
					}
				} else {
					result.push( <tr className="line_holder new" key = {i}>
			                  <td className="diff-line-num old_line new"></td>
			                  <td className="diff-line-num new_line new">{newCount}</td>
			                  <td className="line_content noteable_line new"><span className="line_content-inner">{diff[i]["value"]}</span></td>
			                </tr>);
					newCount++;
				}
			}
		}
		return (
			  <div className="diff__col diff__col--right">
		          <div className="diff__data" style = {{height: this.state.heightt + this.props.modifiedHeght + "px"}}>
		            <table className="diff-table code white">
		              <tbody>
		              {result}
		                {/*<tr className="line_holder">
		                  <td className="diff-line-num old_line">1</td>
		                  <td className="diff-line-num new_line">1</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line one - in sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">2</td>
		                  <td className="diff-line-num new_line">2</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line two - in sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">3</td>
		                  <td className="diff-line-num new_line">3</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line three - in sync</span></td>
		                </tr>
		                <tr className="line_holder old">
		                  <td className="diff-line-num old_line old">4</td>
		                  <td className="diff-line-num new_line old"></td>
		                  <td className="line_content noteable_line old"><span className="line_content-inner">code line one - out of sync</span></td>
		                </tr>
		                <tr className="line_holder old">
		                  <td className="diff-line-num old_line old">5</td>
		                  <td className="diff-line-num new_line old"></td>
		                  <td className="line_content noteable_line old"><span className="line_content-inner">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</span></td>
		                </tr>
		                <tr className="line_holder old">
		                  <td className="diff-line-num old_line old">6</td>
		                  <td className="diff-line-num new_line old"></td>
		                  <td className="line_content noteable_line old"><span className="line_content-inner">code line three - out of sync</span></td>
		                </tr>
		                <tr className="line_holder new">
		                  <td className="diff-line-num old_line new"></td>
		                  <td className="diff-line-num new_line new">4</td>
		                  <td className="line_content noteable_line new"><span className="line_content-inner">code line one - out of sync</span></td>
		                </tr>
		                <tr className="line_holder new">
		                  <td className="diff-line-num old_line new"></td>
		                  <td className="diff-line-num new_line new">5</td>
		                  <td className="line_content noteable_line new"><span className="line_content-inner">code line one - out of sync</span></td>
		                </tr>
		                <tr className="line_holder new">
		                  <td className="diff-line-num old_line new"></td>
		                  <td className="diff-line-num new_line new">6</td>
		                  <td className="line_content noteable_line new"><span className="line_content-inner">code line one - out of sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">7</td>
		                  <td className="diff-line-num new_line">7</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line one - in sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">8</td>
		                  <td className="diff-line-num new_line">8</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line two - in sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">9</td>
		                  <td className="diff-line-num new_line">9</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line three - in sync</span></td>
		                </tr>
		                <tr className="line_holder match">
		                  <td className="diff-line-num old_line">...</td>
		                  <td className="diff-line-num new_line">...</td>
		                  <td className="line_content match"><span className="line_content-inner">@@ collapsed lines @@</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">21</td>
		                  <td className="diff-line-num new_line">21</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line one - in sync - out of sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">22</td>
		                  <td className="diff-line-num new_line">22</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line two - in sync - out of sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">23</td>
		                  <td className="diff-line-num new_line">23</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line three - in sync - out of sync</span></td>
		                </tr>
		                <tr className="line_holder old">
		                  <td className="diff-line-num old_line old">24</td>
		                  <td className="diff-line-num new_line old"></td>
		                  <td className="line_content noteable_line old"><span className="line_content-inner">code line one - out of sync</span></td>
		                </tr>
		                <tr className="line_holder old">
		                  <td className="diff-line-num old_line old">25</td>
		                  <td className="diff-line-num new_line old"></td>
		                  <td className="line_content noteable_line old"><span className="line_content-inner">code line two - out of sync</span></td>
		                </tr>
		                <tr className="line_holder old">
		                  <td className="diff-line-num old_line old">26</td>
		                  <td className="diff-line-num new_line old"></td>
		                  <td className="line_content noteable_line old"><span className="line_content-inner">code line three - out of sync</span></td>
		                </tr>
		                <tr className="line_holder new">
		                  <td className="diff-line-num old_line new"></td>
		                  <td className="diff-line-num new_line new">24</td>
		                  <td className="line_content noteable_line new"><span className="line_content-inner">code line one - out of sync</span></td>
		                </tr>
		                <tr className="line_holder new">
		                  <td className="diff-line-num old_line new"></td>
		                  <td className="diff-line-num new_line new">25</td>
		                  <td className="line_content noteable_line new"><span className="line_content-inner">code line one - out of sync</span></td>
		                </tr>
		                <tr className="line_holder new">
		                  <td className="diff-line-num old_line new"></td>
		                  <td className="diff-line-num new_line new">26</td>
		                  <td className="line_content noteable_line new"><span className="line_content-inner">code line one - out of sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">27</td>
		                  <td className="diff-line-num new_line">27</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line one - in sync - out of sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">28</td>
		                  <td className="diff-line-num new_line">28</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line two - in sync - out of sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">29</td>
		                  <td className="diff-line-num new_line">29</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line three - in sync - out of sync</span></td>
		                </tr>
		                <tr className="line_holder match">
		                  <td className="diff-line-num old_line">...</td>
		                  <td className="diff-line-num new_line">...</td>
		                  <td className="line_content match"><span className="line_content-inner">@@ collapsed lines @@</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">41</td>
		                  <td className="diff-line-num new_line">41</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line one - in sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">42</td>
		                  <td className="diff-line-num new_line">42</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line two - in sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">43</td>
		                  <td className="diff-line-num new_line">43</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line three - in sync</span></td>
		                </tr>
		                <tr className="line_holder old">
		                  <td className="diff-line-num old_line old">44</td>
		                  <td className="diff-line-num new_line old"></td>
		                  <td className="line_content noteable_line old"><span className="line_content-inner">code line one - out of sync</span></td>
		                </tr>
		                <tr className="line_holder old">
		                  <td className="diff-line-num old_line old">45</td>
		                  <td className="diff-line-num new_line old"></td>
		                  <td className="line_content noteable_line old"><span className="line_content-inner">code line two - out of sync</span></td>
		                </tr>
		                <tr className="line_holder old">
		                  <td className="diff-line-num old_line old">46</td>
		                  <td className="diff-line-num new_line old"></td>
		                  <td className="line_content noteable_line old"><span className="line_content-inner">code line three - out of sync</span></td>
		                </tr>
		                <tr className="line_holder new">
		                  <td className="diff-line-num old_line new"></td>
		                  <td className="diff-line-num new_line new">44</td>
		                  <td className="line_content noteable_line new"><span className="line_content-inner">code line one - out of sync</span></td>
		                </tr>
		                <tr className="line_holder new">
		                  <td className="diff-line-num old_line new"></td>
		                  <td className="diff-line-num new_line new">45</td>
		                  <td className="line_content noteable_line new"><span className="line_content-inner">code line one - out of sync</span></td>
		                </tr>
		                <tr className="line_holder new">
		                  <td className="diff-line-num old_line new"></td>
		                  <td className="diff-line-num new_line new">46</td>
		                  <td className="line_content noteable_line new"><span className="line_content-inner">code line one - out of sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">47</td>
		                  <td className="diff-line-num new_line">47</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line one - in sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">48</td>
		                  <td className="diff-line-num new_line">48</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line two - in sync</span></td>
		                </tr>
		                <tr className="line_holder">
		                  <td className="diff-line-num old_line">49</td>
		                  <td className="diff-line-num new_line">49</td>
		                  <td className="line_content noteable_line"><span className="line_content-inner">code line three - in sync</span></td>
		                </tr>*/}
		              </tbody>
		            </table>
		          </div>
		        </div>
		);
	}
});

export {FileDiffs};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/DiffPushPopup/FileDiffs.jsx
 **/